import { render, staticRenderFns } from "./HandbookBackgrounds.vue?vue&type=template&id=6789536a&lang=pug&"
import script from "./HandbookBackgrounds.vue?vue&type=script&lang=ts&"
export * from "./HandbookBackgrounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports